import api from '@/api'

const state = {
  recursoTipos: []
}

const getters = {
  recursoTipos: (state) => {
    return state.recursoTipos
  },
  recursoTiposGuardias: (state) => {
    return state.recursoTipos.filter(x => x.GUARDIA || x.NUMERO_COMPONENTES)
  },
  gestionInternaByTipoId: (state) => {
    const index = {}
    for (const tipo of state.recursoTipos) {
      if (!tipo?.ID_RECURSO_TIPO) continue
      index[tipo.ID_RECURSO_TIPO.toLowerCase()] = tipo.GESTION_INTERNA
    }
    return index
  }
}

const mutations = {
  SET_TIPOS_RECURSO(state, recursoTipos) {
    state.recursoTipos = recursoTipos
  }
}

const actions = {
  async fetchTiposRecurso({ commit }) {
    try {
      const response = await api.recursoTipo.getTiposRecurso()
      commit('SET_TIPOS_RECURSO', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
